export const referralFavoriteKeys = {
    all: ['referralFavorite'] as const,
    lists: () => [...referralFavoriteKeys.all, 'list'] as const,
    list: (userId: string) => [...referralFavoriteKeys.lists(), userId] as const,
};
